import React from 'react';
import { useState } from 'react';
import TripsNavBar from '../navbars/trips-navbar';
import withAuth from '../../HOCs/withAuth';
import TripCardList from '../trips/trip-card-list';
import AddTripModal from '../modals/trip/add-trip-modal';
import SortedByModal from '../modals/sorted-by-modal';
import {
  SortByTitleAsc,
  SortByLastUpdateRecentFirst
} from '../../Models/sortby.model';
import { TripsProvider, useTrips } from '../contexts/trips-context';
import PublishTripModal from '../modals/trip/publish-trip-modal';
import CopyModal from '../modals/settings/copy-modal';
import DeleteModal from '../modals/settings/delete-modal';
import EditTripModal from '../modals/trip/edit-trip-modal';
import { SortingProvider, useSorting } from '../contexts/sorting-context';
import { ModalProvider, useModal } from '../contexts/modal-context';
import tripsService from '../../services/trips/trips.service';
import {
  PaginationProvider,
  usePagination
} from '../contexts/pagination-context';
import './trips-page.scss';

function TripsPage() {
  const [showDisplaySortByModal, setShowSortByModal] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const { setRefreshTrips } = useTrips();
  const { sort, setSort } = useSorting();
  const {
    showAddTripModal,
    setShowAddTripModal,
    showEditTripModal,
    setShowEditTripModal,
    showDeleteModal,
    setShowDeleteModal,
    activeTripModalProps,
    setActiveTripModalProps,
    showPublishTripModal,
    setShowPublishTripModal,
    showCopyModal,
    setShowCopyModal,
    showMoveToTripModal,
    setShowMoveToTripModal
  } = useModal();
  const { page, setPage, pageSize, setPageSize } = usePagination();
  // const handleShowCopyModal = () => {
  //   setShowCopyModal(true);
  // };
  // const handleShowEditTripModal = () => {
  //   setShowEditTripModal(true);
  // };
  // const handleShowDeleteModal = () => {
  //   setShowDeleteModal(true);
  // };
  // const handleShowPublishTripModal = () => {
  //   setShowPublishTripModal(true);
  // };
  const handleAddTripStateChange = (state: boolean) => {
    setShowAddTripModal(state);
  };

  const handleSortByStateChange = (state: boolean) => {
    setShowSortByModal(state);
  };

  const handleCloseSortBy = () => {
    //setSort(sortBy);
    setShowSortByModal(false);
    //console.log('sort by', sortBy);
    console.log('sort by', sort);
  };

  const handleCloseAddTrip = () => {
    setShowAddTripModal(false);
    setRefreshTrips(true);
  };

  const handleCloseEditTrip = () => {
    setShowEditTripModal(false);
  };
  const handleDeleteTrip = () => {
    tripsService
      .deleteTrip(activeTripModalProps?.id || '')
      .then(() => {
        setShowDeleteModal(false);
        setRefreshTrips(true);
      })
      .catch((error) => {
        console.error('Error deleting trip:', error);
      });
  };
  const handleClosePublishTrip = () => {
    setShowPublishTripModal(false);
  };
  const handleCloseCopyTrip = () => {
    setShowCopyModal(false);
  };

  const handleSearchChange = (value: string) => {
    setSearchQuery(value);
    // Clear search and refresh if value is empty
    if (!value || value.trim() === '') {
      setRefreshTrips(true);
    }
  };

  const handleSearchSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    console.log('🔍 Search submitted with query:', searchQuery);
    // Trigger refresh with search query
    setRefreshTrips(true);
  };

  return (
    <>
      <div
        className='trips-page-decoration'
        aria-hidden='true'
      ></div>
      <div className='overflow-y-auto trips-page-scroll'>
        <div className='container-px'>
          <TripsNavBar
            onAddTripStateChange={handleAddTripStateChange}
            onSortByStateChange={handleSortByStateChange}
            searchQuery={searchQuery}
            onSearchChange={handleSearchChange}
            onSearchSubmit={handleSearchSubmit}
          />
          <TripCardList
            direction='horizontal'
            searchQuery={searchQuery}
          />
          {/* <Pagination /> */}
          <AddTripModal
            show={showAddTripModal}
            handleClose={handleCloseAddTrip}
          />
          <CopyModal
            show={showCopyModal}
            handleClose={() => setShowCopyModal(false)}
          />
          <EditTripModal
            show={showEditTripModal}
            handleClose={() => setShowEditTripModal(false)}
          />
          <DeleteModal
            title={`Delete Trip: ${activeTripModalProps?.name || 'Trip'}`}
            show={showDeleteModal}
            handleDelete={() => handleDeleteTrip()}
            handleClose={() => setShowDeleteModal(false)}
          />
          <PublishTripModal
            show={showMoveToTripModal}
            handleClose={() => setShowMoveToTripModal(false)}
          />
          <SortedByModal
            show={showDisplaySortByModal}
            handleClose={handleCloseSortBy}
            dataSort={[
              { value: SortByTitleAsc, label: 'From A to Z' },
              { value: SortByLastUpdateRecentFirst, label: 'Newest' }
            ]}
            setSortBy={setSort}
          />
        </div>
      </div>
    </>
  );
}

// export default withAuth(TripsPage);

const TripsPageWithProvider: React.FC = () => {
  return (
    <TripsProvider>
      <PaginationProvider>
        <SortingProvider>
          <ModalProvider>
            <TripsPage />
          </ModalProvider>
        </SortingProvider>
      </PaginationProvider>
    </TripsProvider>
  );
};

export default withAuth(TripsPageWithProvider);
